import { PurpleButton } from "../../../../../components/buttons/purpleButton";
import { IConteudo } from "../../../../../Interfaces/model/IConteudo";
import { ContentSummary, DeleteContentSummaryContainer } from "./styles";

interface Props {
  showDeleteContainer: boolean;
  arrayOfContent: IConteudo[];
  selectedIndex: number;
  deleteOnClick: () => void;
  setSelectedIndex: (index: number) => void;
  disabled?: boolean;
}

export const DeleteContentSummary = ({
  selectedIndex,
  setSelectedIndex,
  arrayOfContent,
  showDeleteContainer,
  deleteOnClick,
  disabled = false,
}: Props) => {
  if (arrayOfContent.length === 0) {
    return <div />;
  }

    return (
      <DeleteContentSummaryContainer
        style={{ display: showDeleteContainer ? "grid" : "none" }}
      >
        <h1>Deletar conteúdo</h1>
        <select
          value={selectedIndex}
          disabled={disabled}
          onChange={(e) => setSelectedIndex(Number.parseInt(e.target.value))}
        >
          {arrayOfContent.map((content, index) => (
            <option key={index} value={index}>
              Bloco de conteúdo: {index + 1}
            </option>
          ))}
        </select>

        <ContentSummary>
          <h3>Bloco de conteúdo: {selectedIndex + 1}</h3>
          <div>
            <h2>Subtitulo: </h2>
            <p>{arrayOfContent[selectedIndex].subtitulo ?? ""}</p>
          </div>
          <div>
            <h2>Paragrafo: </h2>
            <p>{arrayOfContent[selectedIndex].paragrafo ?? ""}</p>
          </div>
          <PurpleButton
            title="Deletar conteúdo"
            disabled={disabled}
            onClick={deleteOnClick}
          />
        </ContentSummary>
      </DeleteContentSummaryContainer>
    );
};
